// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .app-main-inner .app-main-row[data-v-37e745f2]  .el-form-item__content {\n  width: 160px;\n}\n#app .app-main-inner .app-main-row[data-v-37e745f2]  .el-form-item__content .el-input-number--mini {\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
